<template>
  <div
    class="num-container"
    :style="{ height: `${numSize}`, width: mul ? '' : numSize }"
    :class="{ single: !mul }"
  >
    <template v-if="mul">
      <div
        class="radius left"
        :style="{ 'border-radius': `${numSize} 0 0 ${numSize}` }"
      ></div>
      <div class="num-text">
        <div style="line-height: 1">{{ num }}</div>
      </div>
      <div
        class="radius right"
        :style="{ 'border-radius': `0 ${numSize} ${numSize} 0` }"
      ></div>
    </template>
    <template v-else>
      <div>{{ num }}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "NumberShowComponent",
  props: {
    num: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    mul() {
      return this.num > 9;
    },
    numSize() {
      return `${this.size}px`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../assets/style/theme.less";

@radius: 18px;
.num-container {
  height: @radius;
  display: flex;
  align-items: center;
  color: white;
  position: relative;
  font-size: 11px;
  &.single {
    background-color: @theme-color;
    border-radius: 50%;
    width: @radius;
    justify-content: center;
    border: 1px solid white;
  }
  .num-text {
    background-color: @theme-color;
    height: @radius;
    z-index: 1;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .radius {
    width: @radius / 2;
    height: @radius;
    background-color: @theme-color;
    position: relative;
    &.right {
      left: -1px;
      border: 1px solid white;
    }
    &.left {
      right: -1px;
      border: 1px solid white;
    }
  }
}
</style>
